// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3wbAb","content":"Consent_content__3Y231","footer":"Consent_footer__8uS5o"};